"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.preferentialExchanges = void 0;
exports.preferentialExchanges = [
    {
        name: 'Prague Stock Exchange ',
        symbol: 'PR',
    },
    {
        name: 'USA Stocks',
        symbol: 'US',
    },
    {
        name: 'XETRA Exchange',
        symbol: 'XETRA',
    },
    {
        name: 'London Exchange',
        symbol: 'LSE',
    },
];
//# sourceMappingURL=preferential-exchanges.js.map